import { render } from "./IoTTab.vue?vue&type=template&id=2dcf1970"
import script from "./IoTTab.vue?vue&type=script&lang=js"
export * from "./IoTTab.vue?vue&type=script&lang=js"
script.render = render

export default script